export default "__VITE_ASSET__DycLK3QR__"